const MAX_PRODUCTS = 20;

if (!customElements.get('license-related-products')) {
  customElements.define(
    'license-related-products',
    class LicenseRelatedProducts extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.grid = this.querySelector('[data-license-related-grid]');
        this.moreLink = this.querySelector('[data-license-related-more]');
        this.searchUrl = this.dataset.searchUrl || '';
        this.abortController = new AbortController();

        this.load();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      async load() {
        if (!this.grid || !this.searchUrl) return;

        try {
          const { count, markup } = await this.fetchFilteredProductCards(this.abortController.signal);

          if (!markup) return;

          this.grid.innerHTML = markup;
          if (this.moreLink) {
            this.moreLink.hidden = count < MAX_PRODUCTS;
          }
          this.hidden = false;
          this.dispatchEvent(new CustomEvent('product-recommendations:loaded', { bubbles: true }));
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.error('Unable to load license-related products.', error);
          }
        }
      }

      async fetchFilteredProductCards(signal) {
        const requestUrl = new URL(this.searchUrl, window.location.origin);
        requestUrl.searchParams.set('view', 'license-related-products');

        const response = await fetch(requestUrl.toString(), {
          credentials: 'same-origin',
          signal,
        });
        if (!response.ok) {
          throw new Error(`License-related products request failed with status ${response.status}.`);
        }

        const responseMarkup = await response.text();
        const documentFragment = new DOMParser().parseFromString(responseMarkup, 'text/html');
        const productItems = Array.from(documentFragment.querySelectorAll('[data-license-related-card]'));

        const limitedProductItems = productItems.slice(0, MAX_PRODUCTS);

        return {
          count: productItems.length,
          markup: limitedProductItems
            .map(
              (productItem, index) =>
                `<li class="product-grid__item product-grid__item--${index}">${productItem.innerHTML}</li>`,
            )
            .join(''),
        };
      }
    }
  );
}
